import {Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	gap: 8px;
	padding: 16px;
	margin-bottom: 24px;
	box-sizing: border-box;
	border: ${({theme}) => `1px solid ${theme.palette.divider}`};
	border-radius: 8px;
`;

export {StyledStack};
